import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
}                                                                     from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, Subscription} from 'rxjs';
import {
  ApDynformsConfigFieldset
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerWizardBreadcrumbsStepper,
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApDynComponentComponent
}                                                                     from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  map,
  tap
}                                                                     from 'rxjs/operators';
import {
  ApDynformsConfigTextbox
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-textbox';
import {
  ApDynformsConfigComboBox
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-combobox';
import {
  ApDynformsConfigDatepicker
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {
  ApDynGridStatusColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  MapViewMode
}                                                                     from '../../ap-interface';
import {
  ApDynGridGroupColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  FieldStore
}                                                                     from '../../stores/farm/field.store';
import {
  MapViewStore
}                                                                     from '../../stores/layout/mapview.store';
import {
  LanguageStore
}                                                                     from '../../stores/translation/language.store';
import {
  CropRotationStore
}                                                                     from '../../stores/farm/crop.rotation.store';
import {
  CampaignYearStore
}                                                                     from '../../stores/login/campaignyear.store';
import {
  CropTypeStore
}                                                                     from '../../stores/base-data/crop.types.store';
import {
  ApDynGridEditColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  FormStore
}                                                                     from '../../stores/layout/form.store';
import {
  ApGuidUtil,
  GetRoundNumericPipe
}                                                                     from '../../ap-utils';
import {
  SettingsStore
}                                                                     from '../../stores/base-data/settings.store';
import {
  GetRoundNumericService
}                                                                     from '../../ap-utils/service/get-round-numeric.service';
import {
  Validators
}                                                                     from '@angular/forms';
import {
  ApDynformsValidator
}                                                                     from '../../ap-dynforms/ap-dynforms-validator';
import {
  ApplicationMapConfig
} from './ap-n-fertilization-planning-configs/application-map.config';
import {
  TargetRateConfig
} from './ap-n-fertilization-planning-configs/target-rate.config';
import {
  NFertilizationConfig
} from './ap-n-fertilization-planning-configs/n-fertilization.config';
import {
  RapeFertilizationConfig
}                                                                     from './ap-n-fertilization-planning-configs/rape-fertilization.config';
import {
  ApDynformsConfigTextarea
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-textarea';
import {
  CurveCreator
}                                                                     from './helpers/curve-creator';
import {
  ObjectFactory
}                                                                     from 'ts-tooling';
import {
  TranslationStore
}                                                                     from '../../stores/translation/translation.store';
import {
  NFertilizationStore
}                                                                     from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApGetCropService
}                                                                     from '../../stores/services/ap-get-crop.service';
import {
  LoginStore
} from '../../stores/login/login.store';
import {
  BoniturConfig
} from './ap-n-fertilization-planning-configs/bonitur.config';
import {
  ModalDialogStore
} from '../../stores/dialog/modal.dialog.store';
import {
  IModalDialogData,
  ModalDialogButtonDisable
}                                                                     from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  OperationModesEnum,
  OperationModesStore
}                                                                     from '../../stores/common/operation-modes.store';
import {
  ApplicationModesEnum,
  ApplModesStore
}                                                                     from '../../stores/common/appl-modes.store';
import {
  GeneralConfig
}                                                                     from './ap-n-fertilization-planning-configs/general.config';
import {
  ApDateService
}                                                                     from '../../ap-core/services/ap-date-service';
import {
  UnitsStore
}                                                                     from '../../stores/common/units.store';
import {
  NotifyStore
}                                                                     from '../../stores/dialog/notify.store';
import {
  MapStore
}                                                                     from '../../stores/map/map.store';
import {
  RouterStore
}                                                                     from '../../stores/router/router.store';
import {
  IGridStatus
}                                                                     from '../../ap-interface/interfaces/ap-grid-status.interface';
import {
  StatisticStore
}                                                                     from '../../stores/statistic/statistic.store';
import {
  NFertilizationService
}                                                                     from '../../services/data/n-fertilization.service';
import {
  INFertilizationPlanFieldToSelectGridItem,
  INFertilizationPlanningPlanBookData,
  NPlanningEntryComponentData
}                                                                     from './types/n-fertilization-planning-entry.types';
import {
  ApBaseWizardSteps
}                                                                     from '../../ap-utils/enums/ap-base-wizard-steps';
import {
  BasicFertilisationSummariesStore
}                                                                     from '../../stores/taskmanagement/basic.fertilisation.summaries.store';
import {
  SensorStore
}                                                                     from '../../stores/sensor/sensor.store';
import {
  MapFactoryStyler
}                                                                     from '../../map-factory/style';
import {
  NFertilizationPlanningEntryService
}                                                                     from './services/n-fertilization-planning-entry.service';
import {
  ApElementType
}                                                                     from '../../ap-interface/enums/ap-elements-type.enum';
import {
  ApplicationMapAbsoluteConfig
}                                                                     from './ap-n-fertilization-planning-configs/application-map-absolute.config';
import {
  ApplicationSettingsStore
}                                                                     from '../../stores/agronomic/application-settings-store.service';
import {
  NFertilizationCommonEntryService
}                                                                     from './services/n-fertilization-common-entry.service';
import {
  nameOf
}                                                                     from '../../ap-core/utils/ap-name-of';
import {
  IOperationModeAppSetting
}                                                                     from '../../types/application-settings.types';
import {
  ScanService
}                                                                     from '../../services/data/scan.service';
import {
  BestScanData,
  BestScanType
}                                                                     from '../../types/scan.types';
import {NFertilizationPlantProtectionService}                         from '../../services/data/n-fertilization-plant-protection.service';
import {ApNFertilizationCommonService}                                from '../../n-fertilization/services/ap-n-fertilization.common.service';
import {ApplicationSettingsService}                                   from '../../services/data/application-settings.service';
import {
  GetRoundNumericPipeConfig
}                                                                     from '../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import {
  UniformConfig
}                                                                     from './ap-n-fertilization-planning-configs/uniform.config';
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import INFertilizationSummary = Data.TaskManagement.INFertilizationSummary;
import ICropTypes = Data.BaseData.ICropTypes;
import ApValidationLevel = Data.Api.Validation.ApValidationLevel;
import ISensorFieldData = Data.Sensor.ISensorFieldData;
import IGuid = System.IGuid;
import INPlanningData = Data.NFertilization.INPlanningData;
import ScanType = Data.NDI.Enums.ScanType;

@Component({
  selector: 'ap-n-fertilization-planning',
  template: `
    <ap-dyncomponent [caption]="caption$ | async"
                     [loading$]="loading$"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [columns]="columns$ | async"
                     [fieldSets]="fieldSets$ | async"
                     [errorKeys]="errorKeys$ | async"
                     [canCreate]="false"
                     [canSearch]="true"
                     [items]="items$ | async"
                     [pager]="pager"
                     (edit)="onEdit($event)">
      <div class="ap-form-actions" dynforms.action>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'left'">
          <button kendoButton
                  [id]="'button_prev'"
                  [type]="'button'"
                  [class]="'k-button k-primary button-important'"
                  (click)="formPrevious.emit()">
            <ap-responsive-text [key]="'Global_Back_With_Arrow'"></ap-responsive-text>
          </button>
        </div>
        <div apResponsive
             [sizeMd]="'50-100'"
             [style.text-align]="'center'">
          <ap-breadcrumbs-steper [columns]="breadCrumbsColumns"
                                 [selected]="1">
          </ap-breadcrumbs-steper>
        </div>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'right'">
          <button kendoButton
                  [id]="'button_next'"
                  [disabled]="nextDisabled$ | async"
                  [type]="'button'"
                  [class]="'k-button k-primary button-important'"
                  (click)="formNext.emit()">
            <ap-responsive-text [key]="'Global_Next_With_Arrow'"></ap-responsive-text>
          </button>
        </div>
      </div>
    </ap-dyncomponent>
    <ng-template #diagram>
      <!--ap-line-chart [data$]="chartData$"
                     [noteValues$]="noteValues$"
                     [maxY$]="maxY$"
                     [xAxisLabel]="'N__ChartTitleX'"
                     [yAxisLabel]="'N__ChartTitleY'">
      </ap-line-chart-->
    </ng-template>
  `,
  providers: [
    ApplicationMapConfig,
    ApplicationMapAbsoluteConfig,
    RapeFertilizationConfig,
    NFertilizationConfig,
    TargetRateConfig,
    BoniturConfig,
    UniformConfig,
    NFertilizationPlanningEntryService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApNFertilizationPlanningEntryComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) public dynComponent: ApDynComponentComponent;
  @ViewChild('diagram', {static: false}) public diagramTemplateRef: TemplateRef<any>;

  public data: NPlanningEntryComponentData;
  caption$ = new BehaviorSubject<string>('Nutrients__SelectFieldsTitle');
  errorKeys$ = new BehaviorSubject<string[]>([]);
  columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  fieldSets$ = new BehaviorSubject<ApDynformsConfigFieldset[]>([]);
  items$ = new BehaviorSubject<any[]>(undefined);
  pager: ApDynGridPagerWizardConfig;
  chartData$: Observable<number[][]>;
  noteValues$: Observable<{ value: number, color?: string }[]>;
  breadCrumbsColumns = ['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'];
  loading$: Observable<boolean>;
  canSave$ = new BehaviorSubject<boolean>(false);
  formNext = new EventEmitter<void>();
  formPrevious = new EventEmitter<void>();
  nextDisabled$ = new BehaviorSubject<boolean>(true);
  maxY$: Observable<number>;

  private _statisticUpdateRequested = new EventEmitter<void>();
  private _currentStep = ApBaseWizardSteps.Selection;
  private _onCancelSelection = new EventEmitter<void>();
  private _onNextSelection = new EventEmitter<void>();
  private _onBackOverview = new EventEmitter<void>();
  private _onSaveOverview = new EventEmitter<void>();
  private _selectedFields$ = new BehaviorSubject<INFertilizationPlanFieldToSelectGridItem[]>([]);
  private _formValues = {};
  private _isRapeCrop: boolean;
  private _cropForDetails: string;
  private _selectedFieldsCropType: ICropTypes | undefined;
  private _operationModeAppSetting: IOperationModeAppSetting | undefined;
  private _operationModeAppSettings: IOperationModeAppSetting[] = [];
  private _nPlanBooks: INFertilizationPlanningPlanBookData[];
  private _subscriptions: Subscription[] = [];
  private _selectFieldSubscriptions: Subscription[] = [];
  private _formSubscriptions: Subscription[] = [];
  private _overviewSubscriptions: Subscription[] = [];

  constructor(private applicationModesStore: ApplModesStore,
              private campaignYearStore: CampaignYearStore,
              private cropRotationStore: CropRotationStore,
              private cropService: ApGetCropService,
              private cropTypeStore: CropTypeStore,
              private dateService: ApDateService,
              private fieldStore: FieldStore,
              private generalConfig: GeneralConfig,
              private formStore: FormStore,
              private languageStore: LanguageStore,
              private loginStore: LoginStore,
              private mapViewStore: MapViewStore,
              private modalDialogStore: ModalDialogStore,
              private notifyStore: NotifyStore,
              private nFertilizationStore: NFertilizationStore,
              private operationModesStore: OperationModesStore,
              private basicFertilisationSummariesStore: BasicFertilisationSummariesStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private roundNumericService: GetRoundNumericService,
              private settingsStore: SettingsStore,
              private translationStore: TranslationStore,
              private unitStore: UnitsStore,
              private mapStore: MapStore,
              private routerStore: RouterStore,
              private nFertilizationService: NFertilizationService,
              private sensorStore: SensorStore,
              private statisticStore: StatisticStore,
              private scanService: ScanService,
              private applicationSettingsService: ApplicationSettingsService,
              private nPlanningEntryService: NFertilizationPlanningEntryService,
              private nFertilizationCommonService: ApNFertilizationCommonService,
              private nFertilizationCommonEntryService: NFertilizationCommonEntryService,
              private nFertilizationPlantProtectionService: NFertilizationPlantProtectionService,
              private applicationSettingsStore: ApplicationSettingsStore,
              private applicationMapAbsoluteConfig: ApplicationMapAbsoluteConfig,
              private uniformConfig: UniformConfig,
              private boniturConfig: BoniturConfig,
              private targetRateConfig: TargetRateConfig,
              private applicationMapConfig: ApplicationMapConfig,
              private nFertilizationConfig: NFertilizationConfig,
              private rapeFertilizationConfig: RapeFertilizationConfig) {
  }

  public ngOnInit(): void {
    this.nPlanningEntryService.setComponentData(this.data);
    this.nPlanningEntryService.initData();
    this._gridBuilderSelectionGrid();
  }

  public ngAfterContentInit(): void {
    setTimeout(() => this.sensorStore.loadSensorFieldData());
    this._subscriptions.push(this.dynComponent.SelectedItems$.pipe(debounceTime(250)).subscribe(() => {
      this._statisticUpdateRequested?.emit();
    }));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(() => {
      this._fieldSelection();
    }));
    this._subscriptions.push(
      combineLatest([
        this.dynComponent.gridSubject,
        this.caption$,
      ]).pipe(
        filter(([grid, caption]) => !!grid && caption === 'Nutrients__SelectFieldsTitle')
      ).subscribe(([grid]) => {
        grid.gridPaging.setSelectedKeys(this.fieldStore.getSelectedFieldIds());
      })
    );
    this._subscriptions.push(this._onCancelSelection.subscribe(() => this._onCloseForm()));
    this._subscriptions.push(this._onNextSelection.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Details;
      this._selectFieldSubscriptions.forEach(x => x?.unsubscribe());
      const selectedFields = this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[];
      this._selectedFields$.next(selectedFields);
      this._isRapeCrop = this.nFertilizationService.isRapeCrop(selectedFields.map(x => x.CropId));
      this._formBuilderGeneral();
      this._selectFieldSubscriptions.forEach(x => x.unsubscribe());
      this.dynComponent.saveGridDescriptors('Selection');
    }));
    this._subscriptions.push(this.formPrevious.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Selection;
      this._formSubscriptions.forEach(x => x?.unsubscribe());
      this._gridBuilderSelectionGrid();
      this.dynComponent.loadGridDescriptors('Selection');
      this._formValues = ObjectFactory.Merge(this._formValues, this.dynComponent.getForm().value);
    }));
    this._subscriptions.push(this.formNext.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Overview;
      this._formSubscriptions.forEach(x => x?.unsubscribe());
      this._formValues = ObjectFactory.Merge(this._formValues, this.dynComponent.getForm().value);
      this._gridBuilderOverview();
      this.dynComponent.loadGridDescriptors('Overview');
    }));
    this._subscriptions.push(this._onBackOverview.subscribe(() => {
      this._currentStep = ApBaseWizardSteps.Details;
      this._overviewSubscriptions.forEach(x => x?.unsubscribe());
      this._clearMap();
      this._formBuilderGeneral();
      this.dynComponent.saveGridDescriptors('Overview');
      this.statisticStore.removeStatisticData();
    }));
    this._subscriptions.push(this._onSaveOverview.subscribe(() => {
      this._save();
      this._onCloseForm();
    }));
    this._subscriptions.push(this._statisticUpdateRequested.pipe(debounceTime(100)).subscribe(() => {
      this._generateStats();
    }));
    this._subscriptions.push(this.items$.subscribe(_ => this._statisticUpdateRequested.emit()));
    this._subscriptions.push(this.canSave$.subscribe(value => {
      this._canSaveCheck(value);
    }));
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s?.unsubscribe());
    this._selectFieldSubscriptions.forEach(x => x?.unsubscribe());
    this._formSubscriptions.forEach(x => x?.unsubscribe());
    this._overviewSubscriptions.forEach(x => x?.unsubscribe());
  }

  public onEdit(dataItem: any): void {
    dataItem = ObjectFactory.Copy(dataItem);
    const copiedFormValues = ObjectFactory.Copy(this._formValues);
    // workaround for our lovely <any> problem in n-fertilization
    // the dataItem from the grid contains '-' text values for numeric columns
    // as it is passed to the form those strings cannot be parsed as number and
    // this leads to a client error when editing a single row
    // ==> replace all '-' with undefined before passing it to the modalDialog
    for (const dataItemProperty of Object.keys(dataItem)) {
      if (dataItem[dataItemProperty] === '-') {
        dataItem[dataItemProperty] = undefined;
      }
    }
    this._updateDataForSingleEdit(copiedFormValues, dataItem);
    this.modalDialogStore.setModalDialogData({
      buttons: [
        {
          key: 'cancel',
          text: 'Global__Cancel',
          primary: false
        },
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
          disable: ModalDialogButtonDisable.FormInvalid,
        }
      ],
      show: true,
      title: this.translationStore.FindTranslationForSelectedLanguage('Docu_Ini__Edit'),
      formConfig: {
        fieldSets: this._getFieldSets(dataItem, copiedFormValues, this.modalDialogStore.listenChanges()),
        values: copiedFormValues
      },
      values: copiedFormValues
    } as IModalDialogData);
    const resultSubscription = this.modalDialogStore.Listen(s => s.result)
      .subscribe((result) => {
        if (result?.key === 'apply') {
          this._updateOverviewItems({ids: [dataItem['Id']], value: result.formValues});
          this._clearMap();
          resultSubscription.unsubscribe();
        } else if (result?.key === 'cancel' || result?.key === '') {
          resultSubscription.unsubscribe();
        }
      });
  }

  private _updateDataForSingleEdit(formValues: any, dataItem: any): void {
    if (!this.nFertilizationCommonEntryService.isApplicationMapOrAbsolute(this._operationModeAppSetting?.OperationMode)) {
      formValues['Threshold'] = dataItem['Threshold'];
      formValues['Constant'] = dataItem['Constant'];
      formValues['Minimum'] = dataItem['Minimum'];
      formValues['Maximum'] = dataItem['Maximum'];
    }
    if (this._operationModeAppSetting?.OperationMode !== OperationModesEnum.ApplicationMapAbsolute) {
      formValues['DeadBioMass'] = dataItem['DeadBioMass'];
      formValues['Amount'] = dataItem['Amount'];
    }
    formValues['ControlFactor'] = dataItem['ControlFactor'];
    formValues['Note'] = dataItem['Note'];
    formValues['ECStage'] = dataItem['ECStage'];
    formValues['Driver'] = dataItem['Driver'];
    formValues['Instrument'] = dataItem['Instrument'];
    formValues['Machine'] = dataItem['Machine'];
  }

  private _gridBuilderSelectionGrid(): void {
    this.caption$.next('Nutrients__SelectFieldsTitle');
    this.fieldSets$.next([]);
    this.loading$ = combineLatest([
      this.fieldStore.Listen((s) => s.loading),
      this.cropRotationStore.Listen((s) => s.historyLoading),
      this.campaignYearStore.Listen((s) => s.loading),
      this.cropTypeStore.Listen((s) => s.loading),
      this.sensorStore.Listen((s) => s.loading),
      this.applicationSettingsStore.Loading$
    ]).pipe(
      map((loadings) => loadings.some(l => l))
    );
    this.columns$ = combineLatest([
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$
    ]).pipe(
      filter(([language, settings]) => !!language && !!settings),
      map(([language, settings]) => ({language, setting: settings})),
      map((p) => [
        new ApDynGridStatusColumnConfig({
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Status'),
          class: nameOf<INFertilizationPlanFieldToSelectGridItem>('StatusClass'),
          description: nameOf<INFertilizationPlanFieldToSelectGridItem>('StatusDesc'),
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Nr'),
          width: 60,
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini_Subnumber',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('TNr'),
          width: 60,
          hide: true,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('NrTNr'),
          width: 70,
          filterable: true,
          headerFilterable: true,
          hide: new ApDynGridColumnHideConfig({
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
          })
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Name',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Name'),
          width: 180,
          filterable: true,
          sortIndex: 0,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Area'),
          width: 60,
          filterable: true,
          headerFilterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          tooltip: (dataItem) => dataItem['Area'],
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [p.setting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Crop',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Crop'),
          width: 100,
          filterable: true,
          headerFilterable: true,
          groupIndex: 0,
          groupDesc: true
        }),
        new ApDynGridStatusColumnConfig({
          field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('state')}`,
          class: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('class')}`,
          description: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('description')}`,
          filterable: true,
          hide: new ApDynGridColumnHideConfig({
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
          })
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__latest_Sensor_reading',
          hide: true,
          groupColumns: [
            new ApDynGridStatusColumnConfig({
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('state')}`,
              class: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('class')}`,
              description: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('description')}`,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__EC',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Ec')}`,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              width: 40,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Date',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('Created')}`,
              format: p.language.DateFormat,
              width: 80,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__AvgShort',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('NUptakeAvg')}`,
              width: 60,
              cssClass: 'right',
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [p.setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }],
              filterType: FilterType.NUMBER,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('NUptakeMin')}`,
              width: 60,
              filterable: true,
              cssClass: 'right',
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [p.setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }],
              filterType: FilterType.NUMBER,
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: `${nameOf<INFertilizationPlanFieldToSelectGridItem>('ScanData')}.${nameOf<BestScanData>('NUptakeMax')}`,
              width: 60,
              filterable: true,
              cssClass: 'right',
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [p.setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
              }],
              filterType: FilterType.NUMBER,
            }),
          ]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Nutrients__Remaining',
          field: nameOf<INFertilizationPlanFieldToSelectGridItem>('Remaining'),
          width: 60,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          hide: true,
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [p.setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
          }]
        }),
      ]),
    );
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global__Cancel', this._onCancelSelection),
      new ApDynGridPagerWizardBreadcrumbsStepper(
        ['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'], 0),
      new ApDynGridPagerWizardButton('Global_Next_With_Arrow', this._onNextSelection, {
        active: this._activeItems()
      })
    );
    this._selectFieldSubscriptions.push(
      combineLatest([
        this._activeItems(),
        this.dynComponent.SelectedItems$
      ]).pipe(
        debounceTime(10)
      ).subscribe(([active, items]) => {
        this.errorKeys$.next(active ? [] : items.map((item) => item['Id']));
        if (!active && items.length > 1 &&
          items.some((i) => i['EppoCode'] !== items[0]['EppoCode'])) {
          this.notifyStore.addMessage({
            Level: ApValidationLevel.Error,
            Counter: 1,
            ErrorKey: 'Global__Various_Crop_Selected',
            UserId: null,
            UserName: null,
            DisplayTimeout: 5,
            Parameters: null
          });
        }
      })
    );
    this._selectFieldSubscriptions.push(
      combineLatest([
        this.fieldStore.Listen(s => s.data),
        this.cropRotationStore.Listen(s => s.history),
        this.campaignYearStore.Listen(s => s.selectedYear),
        this.cropTypeStore.Listen(s => s.cropTypesNames),
        this.nFertilizationStore.GetNeeds$(this.campaignYearStore.getSelectedCampaignYear()?.Year),
        this.sensorStore.Listen(s => s.data),
        this.nFertilizationStore.Listen(x => x.planBooks),
        this.nFertilizationStore.Listen(x => x.logfiles),
        this.basicFertilisationSummariesStore.Summaries$,
        this.applicationSettingsStore.Applications$
      ]).pipe(
        filter(([fields, cropRotation]) => fields.length !== 0 && Object.keys(cropRotation).length !== 0),
        map(([fields, cropRotation, year, cropTypes, needs, sensorFieldData, planBooks, logFiles, bfSummaries, _]) => fields.map((field) => {
          const geom = this.fieldStore.getCurrentFieldGeom(field);
          const fieldCrop = cropRotation[field.Id as string];
          const sensorData = sensorFieldData?.Find(x => x?.FieldGeomId === geom?.Id) as ISensorFieldData;
          let crop: any;
          let cropId: any;
          let defaultCropEppoCode: string | null;
          const status: IGridStatus = this._getStatus(fieldCrop[year.Year].MainCrop, sensorData);
          if (fieldCrop) {
            cropId = fieldCrop[year.Year].MainCrop;
            defaultCropEppoCode = this.cropTypeStore.getDefaultCroptype(cropId)?.Eppocode;
            crop = cropTypes[fieldCrop[year.Year].MainCrop];
          }
          const needValue = needs.Find((need) => need.FieldId === field.Id)?.Value ?? null;
          const baseFertPlanBooks = bfSummaries.map(x => x.BasicFertilisationPlanBooks).flat();
          const alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(field, planBooks, logFiles, baseFertPlanBooks);
          const bestScanData = this.scanService.getBestScanData(field, this.getDefaultBestScanStatus());
          return {
            Id: field.Id,
            Status: status.state,
            StatusClass: status.class,
            StatusDesc: status.description,
            Nr: field.FieldNumber,
            TNr: field.FieldSubnumber,
            NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Name: field.FieldName,
            Area: geom ? geom.AreaHa : undefined,
            Crop: crop,
            CropId: cropId,
            EppoCode: defaultCropEppoCode,
            SecondCropId: (this.cropService.getCrop(field, false, 'object') as ICropTypes)?.Id,
            Geom: geom,
            Kind: null,
            Application: null,
            FieldCropEc: this.cropService.getFieldCrop(field)?.EcValue ?? undefined,
            Sum: null,
            DBW: needValue,
            NUptake: null,
            PlanBookId: bestScanData?.PlanId ?? ApGuidUtil.getEmptyGuid(),
            Remaining: this.nFertilizationService.calculateRemainingValue(alreadyApplied, needValue) ?? '-',
            ScanData: bestScanData
          } as INFertilizationPlanFieldToSelectGridItem;
        })),
      ).subscribe((items) => this.items$.next(items))
    );
  }

  private _formBuilderGeneral(): void {
    const cropId = this._selectedFields$.getValue()[0].CropId;
    this._selectedFieldsCropType = this.cropTypeStore.getDefaultCroptype(cropId);
    this.caption$.next('Global__Details');
    this.columns$ = of([]);
    this.maxY$ = this.dynComponent.FormValues$.pipe(
      distinctUntilChanged((previous, current) =>
        current['Maximum'] === previous['Maximum'] &&
        current['ControlRange'] === previous['ControlRange'] &&
        current['TargetRate'] === previous['TargetRate']),
      map((v) => {
        const operationMode = this._operationModeAppSettings.FirstOrDefault(x => x.Id === v['OperationMode'])?.OperationMode;
        return operationMode === OperationModesEnum.ApplicationMap ? v['ControlRange'] + v['TargetRate'] : v['Maximum'];
      })
    );
    this.chartData$ = this.dynComponent.FormValues$.pipe(
      map((values) => {
        const valuesOperationMode = this._operationModeAppSettings.FirstOrDefault(x => x.Id === values['OperationMode'])?.OperationMode;
        return ({
          amount: values['Amount'] !== '' ? values['Amount'] : undefined,
          threshold: values['Threshold'] !== '' ? values['Threshold'] : undefined,
          min: values['Minimum'] !== '' ? values['Minimum'] : undefined,
          max: values['Maximum'] !== '' ? values['Maximum'] : undefined,
          factor: values['ControlFactor'] !== '' ? values['ControlFactor'] : undefined,
          targetRate: values['TargetRate'] !== '' ? values['TargetRate'] : undefined,
          controlRange: values['ControlRange'] !== '' ? values['ControlRange'] : undefined,
          referenceValue: values['ReferenceValue'] !== '' ? values['ReferenceValue'] : undefined,
          operationMode: valuesOperationMode != null ? valuesOperationMode : undefined,
        });
      }),
      distinctUntilChanged((x, y) => JSON.stringify(x) === JSON.stringify(y)),
      map((values) => {
        const avgNUptake =
          this._selectedFields$.getValue().reduce((res, f) => res + f.NUptake, 0)
          / this._selectedFields$.getValue().length;
        if (this.nFertilizationCommonEntryService.isApplicationMapOrAbsolute(values.operationMode)) {
          return CurveCreator.createCurve(
            avgNUptake, values.amount, values.threshold, values.min, values.max, values.factor);
        } else if (values.operationMode === OperationModesEnum.TargetValue) {
          const min = values.targetRate - values.controlRange;
          const max = values.targetRate + values.controlRange;
          return CurveCreator.createCurve(
            avgNUptake, values.targetRate, values.threshold * avgNUptake / 100, min, max, values.factor);
        } else if (values.operationMode === OperationModesEnum.NFertilization) {
          return CurveCreator.createCurve(
            18, values.amount, 6, values.min, values.max, values.factor);
        }
        return undefined;
      }),
    );
    this.noteValues$ = this.dynComponent.FormValues$.pipe(
      map((values) => {
        const valuesOperationMode = this._operationModeAppSettings.FirstOrDefault(x => x.Id === values['OperationMode'])?.OperationMode;
        return ({
          threshold: values['Threshold'] !== '' ? values['Threshold'] : undefined,
          operationMode: valuesOperationMode != null ? valuesOperationMode : undefined
        });
      }),
      distinctUntilChanged((x, y) => JSON.stringify(x) === JSON.stringify(y)),
      map((values) => {
        const avgNUptake =
          this._selectedFields$.getValue().reduce((res, f) => res + f.NUptake, 0)
          / this._selectedFields$.getValue().length;
        if (values.operationMode === OperationModesEnum.TargetValue) {
          values.threshold *= avgNUptake / 100;
        } else if (values.operationMode === OperationModesEnum.NFertilization) {
          return CurveCreator.createNotes(18, values.threshold ? 6 : undefined);
        }
        return CurveCreator.createNotes(avgNUptake, values.threshold);
      }),
    );
    this._formSubscriptions.push(
      this.dynComponent.FormValues$.pipe(
        distinctUntilChanged((previous, current) => previous['Group'] === current['Group']),
      ).subscribe(() => {
        const product = this.dynComponent?.getForm()?.get('Product');
        if (product) {
          product.setValue(undefined);
        }
      })
    );
    this._formSubscriptions.push(
      combineLatest([
        this.dynComponent.Valid$,
        this.fieldSets$
      ]).pipe(
        filter(([, fs]) => fs.length !== 0),
        debounceTime(10),
        delay(1),
        map(([v]) => !v)
      ).subscribe((disable) => {
          this.dynComponent.dynForm.form.markAllAsTouched();
          this.nextDisabled$.next(disable);
        }
      )
    );
    this._formSubscriptions.push(
      combineLatest([
        this.dynComponent.FormValues$,
        this.fieldSets$
      ]).pipe(
        debounceTime(100),
        filter(([values, fieldSets]) => fieldSets.length !== 0 && Object.keys(values).length !== 0),
        tap(([values, _]) => {
          if (!this._formValues['Application'] || !this._formValues['OperationMode']) {
            this._formValues = ObjectFactory.Copy(values);
          }
        }),
        filter(([values, _]) => {
          return !!values['Application'] && !!values['OperationMode'] && !!this._formValues['Application'] && !!this._formValues['OperationMode']
            && (this._formValues['Application'] !== values['Application'] || this._formValues['OperationMode'] !== values['OperationMode']);
        }),
        map(([values, _]) => values),
        distinctUntilChanged((previous, current) => {
          return (!previous['Application'] || !previous['OperationMode'])
            || (previous['Application'] === current['Application'] && previous['OperationMode'] === current['OperationMode'])
            || (this._formValues['Application'] === current['Application'] && this._formValues['OperationMode'] === current['OperationMode']);
        }),
        tap((values) => {
          this._operationModeAppSetting = undefined;
          const applicationMode = values['Application'] as ApplicationModesEnum;
          const operationModeId = values['OperationMode'] as string;
          if (applicationMode !== this._formValues['Application']) {
            this._updateOperationModeAppSettings(applicationMode);
            this._operationModeAppSetting = this._operationModeAppSettings?.find(x => x.ApplicationMode === applicationMode);
          } else {
            this._operationModeAppSetting = this._operationModeAppSettings?.find(x => x.Id === operationModeId);
          }
          values['OperationMode'] = this._operationModeAppSetting.Id;
          if (this.nFertilizationCommonEntryService.isApplicationMapOrAbsolute(this._operationModeAppSetting?.OperationMode)) {
            this._cleanUpFormValues(values);
          }
          this._formValues = ObjectFactory.Copy(values);
        }),
        tap(() => {
          if (this.nFertilizationCommonEntryService.isApplicationMapOrAbsolute(this._operationModeAppSetting?.OperationMode)) {
            return;
          }
          if (!!this._formValues['ControlRange']) {
            this._formValues['Minimum'] = this._formValues['TargetRate'] - this._formValues['ControlRange'];
            this._formValues['Maximum'] = this._formValues['TargetRate'] + this._formValues['ControlRange'];
          }
          this._formValues['DeadBioMass'] = 0;
          this._formValues['Minimum'] = 0;
          if (this._isRapeCrop) {
            this._formValues['ControlFactor'] = 1;
            this._formValues['Maximum'] = 120;
            if (this._operationModeAppSetting?.OperationMode === OperationModesEnum.ApplicationMap) {
              this._formValues['Amount'] = 160;
            }
          } else {
            this._formValues['Maximum'] = 120;
            this._formValues['ControlFactor'] = 2;
          }
        }),
        map(() => {
          return this._createForm(this._formValues['Application'] as ApplicationModesEnum, this._operationModeAppSetting);
        }),
      ).subscribe(fieldSets => {
        this.fieldSets$.next(fieldSets);
        setTimeout(() => this.dynComponent.dynForm.markAsTouched());
      })
    );
    this._cleanUpFormValuesOnCropChanged();
    this.fieldSets$.next(
      this._createForm(this._formValues['Application'] as ApplicationModesEnum, this._operationModeAppSetting)
    );
    this._statisticUpdateRequested.emit();
  }

  private _gridBuilderOverview(): void {
    const operationMode = this._operationModeAppSetting.OperationMode;
    const isApplicationMap = this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(operationMode);
    this.fieldSets$.next([]);
    this.caption$.next('Admin_Pages__Overview');
    this.nFertilizationStore.clearNPlanningStatistic();
    this._createGridDataObjects(isApplicationMap);
    this._initializeGridOverviewItem(isApplicationMap, true);
    this._gridBuilderOverviewColumns(isApplicationMap);
    if (isApplicationMap) {
      this._createNPlanningJob();
    }
    this._statisticUpdateRequested.emit();
  }

  private _activeItems(): Observable<boolean> {
    return this.dynComponent.SelectedItems$.pipe(
      delay(1),
      map((items) =>
        items.length !== 0 &&
        items.every(_ => _?.Status >= 0) &&
        items.every((i) => i['EppoCode'] === items[0]['EppoCode'])
      )
    );
  }

  private _cleanUpFormValuesOnCropChanged(): void {
    const selectedFieldCrops = this._selectedFields$.getValue().map(x => x.Crop);
    const selectedFieldCrop = !selectedFieldCrops || selectedFieldCrops.length <= 0 ? '' : selectedFieldCrops[0];
    if (this._cropForDetails && this._cropForDetails !== selectedFieldCrop) {
      this._formValues['Machine'] = undefined;
      this._formValues['Driver'] = undefined;
      this._formValues['Group'] = undefined;
      this._formValues['Instrument'] = undefined;
      this._formValues['OperationMode'] = undefined;
      this._formValues['Application'] = undefined;
      this._cleanUpFormValues(this._formValues);
    }
    this._cropForDetails = selectedFieldCrop;
  }

  private _cleanUpFormValues(formValues: any): void {
    formValues['Amount'] = undefined;
    formValues['Threshold'] = undefined;
    formValues['DeadBioMass'] = undefined;
    formValues['Minimum'] = undefined;
    formValues['Maximum'] = undefined;
    formValues['Product'] = undefined;
    formValues['Constant'] = undefined;
    formValues['ControlFactor'] = undefined;
    formValues['TargetRate'] = undefined;
    formValues['ControlRange'] = undefined;
    formValues['ReferenceValue'] = undefined;
  }

  private _gridBuilderOverviewColumns(isApplicationMap: boolean): void {
    if (isApplicationMap) {
      this._overviewSubscriptions.push(this.items$
        .pipe(debounceTime(10))
        .subscribe((items) => this.canSave$.next((items.every((i) => !i['ColumnLoading'] && !i['ErrorMessage']))))
      );
    } else {
      this.canSave$.next(true);
    }

    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', this._onBackOverview),
      new ApDynGridPagerWizardBreadcrumbsStepper(['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'], 2),
      new ApDynGridPagerWizardButton('Global__Save', this._onSaveOverview, {active: this.canSave$, id: 'button_save'}),
    );

    this.columns$ = combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data)
    ]).pipe(
      filter(([language, settings]) => !!language && settings.length !== 0),
      map(([language, settings]) => ({language, setting: settings[0]})),
      map((p) => {
        const mapHide = this.mapViewStore.Listen(s => s.mode).pipe(
          map((mapMode) => mapMode === MapViewMode.HIDE));
        let result: ApDynGridColumnConfigBase[] = [
          new ApDynGridStatusColumnConfig({
            field: `Status.${nameOf<IGridStatus>('state')}`,
            class: `Status.${nameOf<IGridStatus>('class')}`,
            description: `Status.${nameOf<IGridStatus>('description')}`,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'Nr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right',
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini_Subnumber',
            field: 'TNr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right',
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'NrTNr',
            width: 70,
            headerFilterable: true,
            hide: new ApDynGridColumnHideConfig({
              selfHide: mapHide
            })
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Name',
            field: 'Name',
            width: 150,
            cssClass: 'left',
            sortIndex: 0,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Area',
            field: 'Area',
            width: 60,
            headerFilterable: true,
            tooltip: (dataItem) => dataItem['Area'],
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [this.settingsStore.FirstSetting.DigitsAfterDecimalPoint]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Crop',
            field: 'Crop',
            width: 80,
            hide: true,
            headerFilterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__EC',
            field: 'ECStage',
            width: 50,
            hide: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
          })
        ];
        const appSettingsParameters = this._operationModeAppSetting?.ApplicationSetting?.Parameter;
        switch (this._operationModeAppSetting?.OperationMode) {
          case OperationModesEnum.ApplicationMap:
            result = result.concat(this.applicationMapConfig.gridBuilderConfig(mapHide, appSettingsParameters));
            break;
          case OperationModesEnum.ApplicationMapAbsolute:
            result = result.concat(this.applicationMapAbsoluteConfig.gridBuilderConfig(mapHide, appSettingsParameters));
            break;
          case OperationModesEnum.TargetValue:
            result = result.concat(this.targetRateConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.NFertilization:
            result = result.concat(this.nFertilizationConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.RapeFertilization:
            result = result.concat(this.rapeFertilizationConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.Constant:
            result = result.concat(this.uniformConfig.gridBuilderConfig());
            break;
        }
        result = result.concat([
          new ApDynGridPropertyColumnConfig({
            title: 'Base__SortItemDate',
            field: 'Date',
            format: p.language.DateFormat,
            hide: true,
            width: 90
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Nutrients__Remaining',
            field: 'Remaining',
            width: 90,
            hide: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [this.settingsStore.FirstSetting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
            }]
          }),
          new ApDynGridGroupColumnConfig({
            title: 'agrioptions_resources',
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: 'Machine.NameWithSign',
                title: 'Base__Engine',
                width: 100,
                hide: true,
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Instrument.Name',
                title: 'AgriConnect_Ini__Tool',
                width: 100,
                hide: true
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Driver.ShortFullName',
                title: 'Docu_Ini__Motorist',
                width: 100,
                hide: true
              })
            ]
          }),
          new ApDynGridEditColumnConfig({})
        ]);
        return result;
      }));
  }

  private _initializeGridOverviewItem(isApplicationMap: boolean, initializeSubscription: boolean): void {
    const nNeeds = this.nFertilizationStore.GetNeeds(this.campaignYearStore.getSelectedCampaignYear().Year);
    const planBooks = this.nFertilizationStore.Listen(x => x.planBooks).getValue();
    const logFiles = this.nFertilizationStore.Listen(x => x.logfiles).getValue();
    const bfPlanBooks = this.basicFertilisationSummariesStore.Summaries.map(x => x.BasicFertilisationPlanBooks).flat();
    if (isApplicationMap && initializeSubscription) {
      this._overviewSubscriptions.push(
        combineLatest([
          this.nFertilizationStore.Listen(s => s.fieldNPlanningStatistic),
          this._selectedFields$,
        ]).subscribe(([fieldNPlanningStatistic, fields]) => {
          this.items$.next(fields.map((field) => {
            const planBook = this._getNPlanningPlanBookData(field.Geom?.Id);
            const needValue = nNeeds.find((need) => need.FieldId === field.Id)?.Value;
            const fieldFromStore = this.fieldStore.getFieldById(field.Id);
            let alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(
              fieldFromStore, planBooks, logFiles, bfPlanBooks);
            const statistic = fieldNPlanningStatistic?.filter(x => x.FieldGeomId === field.Geom.Id) ?? [];
            if (statistic && statistic.length > 0) {
              planBook.ColumnLoading = false;
              if (statistic[0].ErrorText !== null) {
                planBook.HasError = true;
                planBook.ErrorMessage = statistic[0].ErrorText;
              } else {
                planBook.HasError = false;
                planBook.ErrorMessage = '';
                planBook.Amount = this.roundNumericService.roundAsNumber(statistic[0].Mean);
                planBook.Minimum = this.roundNumericService.roundAsNumber(statistic[0].Min);
                planBook.Maximum = this.roundNumericService.roundAsNumber(statistic[0].Max);
                planBook.PlanId = statistic[0].PlanId;
                if (this._isRemainingValueCouldBeApplied(planBook.OperationModeKey)) {
                  alreadyApplied += this.nFertilizationService.getAlreadyApplied(statistic[0].Mean, planBook.ProductId);
                }
              }
            }
            return {
              ...field,
              Id: field.Id,
              Status: this.nFertilizationPlantProtectionService.getStatusForItemOnOverviewStep(planBook.OperationModeKey as OperationModesEnum),
              PlanId: planBook.PlanId,
              OperationMode: planBook.OperationModeKey,
              ApplicationMode: planBook.ApplicationModeKey,
              ErrorMessage: planBook.HasError ? planBook.ErrorMessage : '',
              AvgAmount: planBook.AvgAmount,
              ProductId: planBook.ProductId,
              Threshold: planBook.HasError ? '-' : planBook.Threshold,
              ThresholdAbs: planBook.HasError ? '-' : planBook.ThresholdAbs,
              Constant: planBook.HasError ? '-' : planBook.Constant,
              Minimum: planBook.HasError ? '-' : planBook.Minimum,
              Maximum: planBook.HasError ? '-' : planBook.Maximum,
              Amount: planBook.HasError ? '-' : planBook.Amount,
              ControlFactor: planBook.HasError ? '-' : planBook.ControlFactor,
              ControlFactorDescription: planBook.ControlFactorDescription,
              ECStage: planBook.ECStage,
              TargetRate: planBook.TargetRate,
              ControlRange: planBook.ControlRange,
              ReferenceValue: planBook.ReferenceValue,
              DeadBioMass: planBook.DeadBioMass,
              Driver: planBook.Driver,
              Machine: planBook.Machine,
              Instrument: planBook.Instrument,
              Duration: planBook.Duration,
              Date: planBook.FertilizationDate,
              Remaining: this.nFertilizationService.calculateRemainingValue(alreadyApplied, needValue ?? null),
              ColumnLoading: planBook.ColumnLoading,
              AvgNUptake: planBook.ScanData?.NUptakeAvg
            };
          }));
        })
      );
    } else {
      const selectedFields = this._selectedFields$.getValue();
      this.items$.next(selectedFields.map((field) => {
        const planBook = this._getNPlanningPlanBookData(field.Geom?.Id);
        const needValue = nNeeds.find((need) => need.FieldId === field.Id)?.Value;
        const fieldFromStore = this.fieldStore.getFieldById(field.Id);
        let alreadyApplied = this.nFertilizationService.calculateAlreadyAppliedFromContentNPlanBooks(
          fieldFromStore, planBooks, logFiles, bfPlanBooks);
        if (this._isRemainingValueCouldBeApplied(planBook.OperationModeKey)) {
          alreadyApplied += this.nFertilizationService.getAlreadyApplied(planBook.Constant, planBook.ProductId);
        }
        return {
          ...field,
          Id: field.Id,
          Status: this.nFertilizationPlantProtectionService.getStatusForItemOnOverviewStep(planBook.OperationModeKey as OperationModesEnum),
          ErrorMessage: '',
          PlanId: planBook.PlanId,
          OperationMode: planBook.OperationModeKey,
          ApplicationMode: planBook.ApplicationModeKey,
          AvgAmount: planBook.AvgAmount,
          ProductId: planBook.ProductId,
          Threshold: planBook.Threshold,
          ThresholdAbs: planBook.ThresholdAbs,
          ControlFactor: planBook.ControlFactor,
          ControlFactorDescription: this.translationStore.FindTranslationForSelectedLanguage(planBook.ControlFactorDescription),
          Constant: planBook.Constant,
          Minimum: planBook.ControlRange ? planBook.TargetRate - planBook.ControlRange : planBook.Minimum,
          Maximum: planBook.ControlRange ? planBook.TargetRate + planBook.ControlRange : planBook.Maximum,
          ECStage: planBook.ECStage,
          TargetRate: planBook.TargetRate,
          ControlRange: planBook.ControlRange,
          ReferenceValue: planBook.ReferenceValue,
          Amount: planBook.Amount,
          DeadBioMass: planBook.DeadBioMass,
          Driver: planBook.Driver,
          Machine: planBook.Machine,
          Instrument: planBook.Instrument,
          Duration: planBook.Duration,
          Date: planBook.FertilizationDate,
          Remaining: this.nFertilizationService.calculateRemainingValue(alreadyApplied, needValue ?? null),
          ColumnLoading: false,
          AvgNUptake: 0
        };
      }));
    }
  }

  private _getNPlanningPlanBookData(fieldGeomId: IGuid): INFertilizationPlanningPlanBookData {
    return this._nPlanBooks.Find(_ => _.FieldGeomId === fieldGeomId);
  }

  private _createGridDataObjects(isApplicationMap: boolean): void {
    this._nPlanBooks = [];
    const selectedFields = this._selectedFields$.getValue();
    selectedFields.map((field) => {
      const operationModeFromForm = this._operationModeAppSetting?.OperationMode;
      const applicationModeFromForm = this._formValues['Application'] as ApplicationModesEnum;
      const operationModeKey = this.nFertilizationPlantProtectionService.getOperationModeForPlan(operationModeFromForm,
        field.ScanData, this._operationModeAppSetting?.ApplicationSetting);
      const applicationModeKey = this.nFertilizationPlantProtectionService.getApplicationModeForPlan(operationModeKey,
        applicationModeFromForm, field.ScanData);
      const slope = this.nFertilizationPlantProtectionService.getSlope(operationModeKey, this._formValues['ControlFactor'],
        this._isRapeCrop, this._operationModeAppSetting?.ApplicationSetting);
      const controlFactorDescription = this.nFertilizationPlantProtectionService.getControlFactorDescription(operationModeKey,
        slope, this._operationModeAppSetting?.ApplicationSetting, false);
      const nPlanBook = {
        PlanId: isApplicationMap ? ApGuidUtil.generateNewGuid() : ApGuidUtil.getEmptyGuid(),
        FieldGeomId: field?.Geom?.Id,
        FieldId: field.Id,
        OperationModeKey: operationModeKey,
        ApplicationModeKey: applicationModeKey,
        ProductId: !this._formValues['Product'] ? 0 : this._formValues['Product'],
        CropTypeMapId: this.cropTypeStore.getCropTypeMapId(field.CropId),
        Minimum: this._formValues['Minimum'],
        Maximum: this._formValues['Maximum'],
        Threshold: this._formValues['Threshold'] ?? this._formValues['Constant'],
        ThresholdAbs: undefined,
        ControlFactor: slope,
        Amount: this._formValues['Amount'],
        nUptake: this.nFertilizationCommonEntryService.nUptake(operationModeKey, field.ScanData),
        AvgAmount: this._formValues['AvgAmount'],
        ECStage: this._formValues['ECStage'],
        Constant: this._formValues['Constant'],
        DeadBioMass: this._formValues['DeadBioMass'],
        TargetRate: this._formValues['TargetRate'],
        ControlRange: this._formValues['ControlRange'],
        ReferenceValue: this._formValues['ReferenceValue'],
        Driver: this._formValues['Driver'],
        Machine: this._formValues['Machine'],
        Instrument: this._formValues['Instrument'],
        Duration: this._formValues['Duration'],
        FertilizationDate: this._formValues['FertilizationDate'],
        ControlFactorDescription: controlFactorDescription,
        ColumnLoading: true,
        HasError: false,
        ErrorMessage: '',
        ScanData: field.ScanData,
      } as INFertilizationPlanningPlanBookData;
      if (nPlanBook.OperationModeKey === OperationModesEnum.TargetValue) {
        nPlanBook.Minimum = nPlanBook.TargetRate - nPlanBook.ControlRange;
        nPlanBook.Maximum = nPlanBook.TargetRate + nPlanBook.ControlRange;
        nPlanBook.Constant = nPlanBook.TargetRate;
      }
      if (nPlanBook.OperationModeKey === OperationModesEnum.ApplicationMap) {
        nPlanBook.ThresholdAbs = nPlanBook.ScanData.NUptakeAvg * (nPlanBook.Threshold / 100);
      }
      this._nPlanBooks.Add(nPlanBook);
    });
  }

  private _createGeneral(operationModeAppSetting: IOperationModeAppSetting, applicationMode: ApplicationModesEnum): ApDynformsConfigFieldset[] {
    const result: ApDynformsConfigFieldset[] = [];
    const crops = this._selectedFields$.getValue()
      .map((f) => f.Crop)
      .filter((v, i, a) => !!v && a.indexOf(v) === i);
    result.Add(new ApDynformsConfigFieldset({
      key: 'Information',
      legend: 'Global__Information',
      classList: 'informational-fieldset',
      config: [
        new ApDynformsConfigTextbox({
          key: 'Count_Fields',
          label: 'AgriConnect__Count_Fields',
          disabled: true,
          value: this._selectedFields$.getValue().length
        }),
        new ApDynformsConfigTextbox({
          key: 'TotalArea',
          label: 'Nutrients__TotalArea_ha',
          disabled: true,
          value: this.roundNumericService.round(this._selectedFields$.getValue()
              .filter((f) => !!f.Area).reduce((sum, o) => sum + o.Area, 0),
            this.settingsStore.FirstSetting.DigitsAfterDecimalPoint)
        }),
        new ApDynformsConfigTextarea({
          key: 'Crops',
          label: 'Settings__Lbl_Menu_Croptypes',
          disabled: true,
          rows: crops.length > 1 ? 2 : 1,
          value: crops.length ? crops.reduce((a, b) => a === '' ? b : `${a}\n${b}`, '') : '-'
        })
      ]
    }));
    const applicationModes = this._getApplicationMode();
    const selectedYear = this.campaignYearStore.getSelectedCampaignYear();
    result.Add(new ApDynformsConfigFieldset({
      key: 'General',
      legend: 'Global__General_Information',
      config: [
        new ApDynformsConfigComboBox({
          key: 'Application',
          label: 'Nutrients_ClientClasses__Application',
          options: applicationModes,
          valueField: 'key',
          textField: 'text',
          value: applicationMode,
          translate: true,
          validators: [
            new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'}),
          ]
        }),
        new ApDynformsConfigComboBox({
          key: 'OperationMode',
          label: 'Global__OperationMode',
          valueField: nameOf<IOperationModeAppSetting>('Id'),
          textField: nameOf<IOperationModeAppSetting>('Text'),
          infoText: 'Infotext__NF_OperationMode',
          options: this._operationModeAppSettings,
          groupByField: nameOf<IOperationModeAppSetting>('Category'),
          value: this._getOperationModeForDetailsForm(operationModeAppSetting)?.Id,
          translate: true,
          validators: [
            new ApDynformsValidator({validator: Validators.required})
          ]
        }),
        new ApDynformsConfigDatepicker({
          key: 'FertilizationDate',
          label: 'Nutrients__FertilizationDate',
          minDate: this.dateService.toJsDate(this.dateService.toFarmDateFromUtc(selectedYear.DefaultStart)),
          maxDate: this.dateService.toJsDate(this.dateService.toFarmDateFromUtc(selectedYear.DefaultEnd)),
          value: this._formValues['FertilizationDate']
            ? this._formValues['FertilizationDate']
            : new Date(Math.min(new Date().valueOf(), new Date(selectedYear.DefaultEnd).valueOf()))
        }),
        new ApDynformsConfigTextbox({
          key: 'Note',
          label: 'Global__Note',
          value: this._formValues['Note']
        })
      ]
    }));
    if (operationModeAppSetting?.OperationMode !== OperationModesEnum.Bonitur) {
      result.Add(this.generalConfig.getProductFieldSet(this._formValues, this.dynComponent.FormValues$));
    }
    return result;
  }

  private _getOperationModeForDetailsForm(operationModeAppSetting: IOperationModeAppSetting): IOperationModeAppSetting {
    if (this._operationModeAppSettings.length === 0) {
      return undefined;
    }
    if (this._operationModeAppSettings.length === 1) {
      return this._operationModeAppSettings[0];
    }
    if (operationModeAppSetting) {
      return operationModeAppSetting;
    }
    return this._operationModeAppSettings.FirstOrDefault(x => x.Id === this._formValues['OperationMode']);
  }

  private _createForm(application: ApplicationModesEnum | undefined,
                      operationModeAppSetting: IOperationModeAppSetting | undefined): ApDynformsConfigFieldset[] {
    const isFieldsForModal = false;
    const selectedFields = this._selectedFields$.getValue();
    const copiedFormValues = ObjectFactory.Copy(this._formValues);
    // Define which application mode we should to take.
    // From parameters, from summary or select default
    let applicationModeForm = application
      ?? ((this.nPlanningEntryService.componentData.Summary?.ApplicationMode?.Key as ApplicationModesEnum)
        ?? (this._isVariablePossible() ? ApplicationModesEnum.Variable : ApplicationModesEnum.Constant));
    this._updateOperationModeAppSettings(applicationModeForm);
    // Define which operation mode settings we should to take.
    // In case it's null from parameters we need to take if from summary (operation mode and growth stage)
    // Or select default in case summary do not have any info
    if (!operationModeAppSetting) {
      const growthStage = copiedFormValues['EcValue']
        ?? this.nPlanningEntryService.componentData.Summary?.ECValue
        ?? undefined;
      const operationModeFromSummary = this.nPlanningEntryService.componentData.Summary?.OperationMode?.Key as OperationModesEnum;
      operationModeAppSetting = this._operationModeAppSettings.find(x => x.OperationMode === operationModeFromSummary
        && x.ApplicationSetting?.EcMin <= growthStage && x.ApplicationSetting?.EcMax >= growthStage);
      if (!operationModeAppSetting) {
        applicationModeForm = this._isVariablePossible() ? ApplicationModesEnum.Variable : ApplicationModesEnum.Constant;
        this._updateOperationModeAppSettings(applicationModeForm);
        operationModeAppSetting = this._operationModeAppSettings.find(x => x.ApplicationMode === applicationModeForm);
      }
    } else {
      operationModeAppSetting = this._operationModeAppSettings.find(x => x.Id === operationModeAppSetting.Id);
      if (!operationModeAppSetting) {
        operationModeAppSetting = this._operationModeAppSettings.find(x => x.ApplicationMode === applicationModeForm);
      }
    }
    this._operationModeAppSetting = operationModeAppSetting;
    this.nPlanningEntryService.createSummaryAndApplyValues(applicationModeForm, operationModeAppSetting.OperationMode,
      this.data?.PlanBooks, copiedFormValues);
    let result = this._createGeneral(operationModeAppSetting, applicationModeForm);
    if (applicationModeForm === ApplicationModesEnum.Variable) {
      if (this.nFertilizationCommonEntryService.isApplicationMapOrAbsolute(operationModeAppSetting.OperationMode)) {
        this.nFertilizationPlantProtectionService.onApplicationSettingsTextWarning(
          selectedFields.map(x => x.ScanData),
          this._operationModeAppSetting?.ApplicationSetting);
      }
      switch (operationModeAppSetting.OperationMode) {
        case OperationModesEnum.ApplicationMap:
          this.applicationMapConfig.updateFormValuesByParameters(copiedFormValues,
            selectedFields, this._operationModeAppSetting?.ApplicationSetting);
          result = result.concat(
            this.applicationMapConfig.formBuilder(
              copiedFormValues,
              this.dynComponent.FormValues$.pipe(delay(0)),
              this._operationModeAppSetting?.ApplicationSetting,
              isFieldsForModal,
              this.diagramTemplateRef
            )
          );
          break;
        case OperationModesEnum.ApplicationMapAbsolute:
          this.applicationMapAbsoluteConfig.updateFormValuesByParameters(copiedFormValues,
            selectedFields, this._selectedFieldsCropType.CropKey, this._operationModeAppSetting?.ApplicationSetting);
          const areaWeightedAverage = this.nFertilizationCommonService.calculateAreaWeightedAverage(
            selectedFields.map(x => ({Area: x.Area, Average: x.ScanData.NUptakeAvg}))
          );
          result = result.concat(
            this.applicationMapAbsoluteConfig.formBuilder(
              copiedFormValues,
              this.dynComponent.FormValues$.pipe(delay(0)),
              areaWeightedAverage,
              this._selectedFieldsCropType.CropKey,
              this._operationModeAppSetting?.ApplicationSetting,
              isFieldsForModal,
              this.diagramTemplateRef
            )
          );
          break;
        case OperationModesEnum.TargetValue:
          result = result.concat(
            this.targetRateConfig.formBuilder(
              copiedFormValues, this.dynComponent.FormValues$,
              this._isRapeCrop,
              isFieldsForModal, this.diagramTemplateRef
            )
          );
          break;
        case OperationModesEnum.NFertilization:
          result = result.concat(
            this.nFertilizationConfig.formBuilderConfig(
              copiedFormValues, this.dynComponent.FormValues$, this._selectedFieldsCropType.Id,
              this._selectedFieldsCropType.CropKey, isFieldsForModal, this.diagramTemplateRef
            )
          );
          break;
        case OperationModesEnum.RapeFertilization:
          result = result.concat(this.rapeFertilizationConfig.formBuilderConfig(copiedFormValues,
            this.dynComponent.FormValues$, this._selectedFieldsCropType.CropKey, isFieldsForModal));
          break;
        case OperationModesEnum.Bonitur:
          result = result.concat(this.boniturConfig.formBuilder(copiedFormValues, isFieldsForModal));
          break;
      }
    } else if (application === ApplicationModesEnum.Constant) {
      result.Add(this.uniformConfig.formBuilder(copiedFormValues, this.dynComponent.FormValues$,
        isFieldsForModal));
    }
    result.Add(this.generalConfig.getDocuFieldSet(
      copiedFormValues,
      this.dynComponent.FormValues$,
      this.dynComponent.dynForm.form.getRawValue,
      isFieldsForModal));
    return result;
  }

  private _getFieldSets(dataItem: any, values: any, values$: Observable<any>): ApDynformsConfigFieldset[] {
    let fieldSet = [];
    const isFieldsForModal = true;
    const operationMode = dataItem['OperationMode'] as OperationModesEnum;
    switch (operationMode) {
      case OperationModesEnum.ApplicationMap:
        fieldSet = fieldSet.concat(
          this.applicationMapConfig.formBuilder(
            values,
            values$.pipe(delay(0)),
            this._operationModeAppSetting?.ApplicationSetting,
            isFieldsForModal
          )
        );
        break;
      case OperationModesEnum.ApplicationMapAbsolute:
        const selectedItems = this._selectedFields$.getValue();
        const areaWeightedAverage = this.nFertilizationCommonService.calculateAreaWeightedAverage(
          selectedItems.map(x => ({Area: x.Area, Average: x.ScanData.NUptakeAvg}))
        );
        fieldSet = fieldSet.concat(
          this.applicationMapAbsoluteConfig.formBuilder(
            values,
            values$.pipe(delay(0)),
            areaWeightedAverage,
            this._selectedFieldsCropType.CropKey,
            this._operationModeAppSetting?.ApplicationSetting,
            isFieldsForModal
          )
        );
        break;
      case OperationModesEnum.TargetValue:
        fieldSet = fieldSet.concat(
          this.targetRateConfig.formBuilder(values, values$.pipe(delay(0)), this._isRapeCrop, isFieldsForModal)
        );
        break;
      case OperationModesEnum.NFertilization:
        fieldSet = fieldSet.concat(
          this.nFertilizationConfig.formBuilderConfig(values, values$.pipe(delay(0)),
            this._selectedFieldsCropType.Id, this._selectedFieldsCropType.CropKey, isFieldsForModal)
        );
        break;
      case OperationModesEnum.RapeFertilization:
        fieldSet = fieldSet.concat(this.rapeFertilizationConfig.formBuilderConfig(values,
          values$.pipe(delay(0)), this._selectedFieldsCropType.CropKey, isFieldsForModal));
        break;
      case OperationModesEnum.Bonitur:
        fieldSet = fieldSet.concat(this.boniturConfig.formBuilder(values, isFieldsForModal));
        break;
      case OperationModesEnum.Constant:
        fieldSet = fieldSet.concat(this.uniformConfig.formBuilder(values, values$, isFieldsForModal));
        break;
    }
    fieldSet.Add(
      this.generalConfig.getDocuFieldSet(
        values,
        values$.pipe(delay(0)),
        this.modalDialogStore.getFormValues,
        true
      )
    );
    return fieldSet;
  }

  private _getStatus(mainCropId: number, sensorData: ISensorFieldData): IGridStatus {
    const cropType = this.cropTypeStore.getDefaultCroptype(mainCropId);
    const result = {state: undefined, class: undefined, description: undefined} as IGridStatus;
    // Calculate status => APV49-2363
    if (cropType && cropType.IsSensorCrop === true && (!sensorData || sensorData?.CropKey < 1 || cropType.CropKey === sensorData?.CropKey)) {
      result.state = 1;
      result.class = 'ap-status-green';
      result.description = 'Global__Variable_Planning_Possible';
    } else if (!cropType || cropType?.Id < 0) {
      result.state = 0;
      result.class = 'ap-status-yellow';
      result.description = 'Global__No_Var_Planning_Crop';
    } else if (cropType && !cropType?.IsSensorCrop) {
      result.state = 0;
      result.class = 'ap-status-yellow';
      result.description = 'Global__No_Var_Planning_SensorCrop';
      // APV49-2586: Spezielles Handling für den Fall, dass Fruch != Sensorfrucht
      // Gelber Status mit Hinweis, dennoch soll variable Planung möglich sein → State = 1
    } else if (cropType && sensorData && cropType.Id !== sensorData.CroptypeId) {
      result.state = 1;
      result.class = 'ap-status-yellow';
      result.description = 'Global__Crop_not_equals_SensorCrop';
    } else {
      result.state = -1;
      result.class = 'ap-status-red';
      result.description = '';
    }
    return result;
  }

  private _getApplicationMode(): any[] {
    const result = [
      {key: ApplicationModesEnum.Constant, text: ApplicationModesEnum.Constant},
    ];
    if (this._isVariablePossible()) {
      result.push(
        {key: ApplicationModesEnum.Variable, text: ApplicationModesEnum.Variable}
      );
    }
    return result;
  }

  private _updateOperationModeAppSettings(applicationMode: ApplicationModesEnum): void {
    this._operationModeAppSettings = [];
    if (applicationMode === ApplicationModesEnum.Constant) {
      this._operationModeAppSettings.push({
        Id: OperationModesEnum.Constant,
        OperationMode: OperationModesEnum.Constant,
        ApplicationMode: ApplicationModesEnum.Constant,
        Text: OperationModesEnum.Constant,
        Category: 'OperationMode_Group_Map',
        ApplicationSetting: undefined
      });
      return;
    }
    if (applicationMode !== ApplicationModesEnum.Variable) {
      return;
    }
    this._operationModeAppSettings = [{
      Id: OperationModesEnum.Bonitur,
      OperationMode: OperationModesEnum.Bonitur,
      ApplicationMode: ApplicationModesEnum.Variable,
      Text: OperationModesEnum.Bonitur,
      Category: 'OperationMode_Group_Task',
      ApplicationSetting: undefined
    }];
    if (this._isRapeCrop) {
      this._operationModeAppSettings.push({
        Id: OperationModesEnum.RapeFertilization,
        OperationMode: OperationModesEnum.RapeFertilization,
        ApplicationMode: ApplicationModesEnum.Variable,
        Text: OperationModesEnum.RapeFertilization,
        Category: 'OperationMode_Group_Task',
        ApplicationSetting: undefined
      });
    }
    this._operationModeAppSettings.push({
      Id: OperationModesEnum.NFertilization,
      OperationMode: OperationModesEnum.NFertilization,
      ApplicationMode: ApplicationModesEnum.Variable,
      Text: OperationModesEnum.NFertilization,
      Category: 'OperationMode_Group_Task',
      ApplicationSetting: undefined
    });
    this._operationModeAppSettings.push({
      Id: OperationModesEnum.TargetValue,
      OperationMode: OperationModesEnum.TargetValue,
      ApplicationMode: ApplicationModesEnum.Variable,
      Text: OperationModesEnum.TargetValue,
      Category: 'OperationMode_Group_Task',
      ApplicationSetting: undefined
    });
    const selectedFieldsData = this._selectedFields$.getValue();
    if (selectedFieldsData.some(x => x.ScanData.Status.state === 1)) {
      const ecValues = selectedFieldsData.map(x => x?.ScanData?.Ec);
      const applicationMapAbsoluteSettings = this.applicationSettingsService.getApplicationSettingsForEppoAndEcRange(
        OperationModesEnum.ApplicationMapAbsolute,
        selectedFieldsData[0].EppoCode, ecValues
      );
      for (const applicationSetting of applicationMapAbsoluteSettings) {
        const applicationSettingName = applicationSetting.TranslationKey != null ?
          ` (${this.translationStore.FindTranslationForSelectedLanguage(applicationSetting.TranslationKey)})` : '';
        this._operationModeAppSettings.push({
          Id: `${OperationModesEnum.ApplicationMapAbsolute}-${applicationSetting.Id}`,
          OperationMode: OperationModesEnum.ApplicationMapAbsolute,
          ApplicationMode: ApplicationModesEnum.Variable,
          Text: `${this.translationStore.FindTranslationForSelectedLanguage(OperationModesEnum.ApplicationMapAbsolute)}${applicationSettingName}`,
          Category: 'OperationMode_Group_Map',
          ApplicationSetting: applicationSetting
        });
      }
      const applicationMapSettings = this.applicationSettingsService.getApplicationSettingsForEppoAndEcRange(
        OperationModesEnum.ApplicationMap,
        selectedFieldsData[0].EppoCode, ecValues
      );
      for (const applicationSetting of applicationMapSettings) {
        const applicationSettingName = applicationSetting.TranslationKey != null ?
          ` (${this.translationStore.FindTranslationForSelectedLanguage(applicationSetting.TranslationKey)})` : '';
        this._operationModeAppSettings.push({
          Id: `${OperationModesEnum.ApplicationMap}-${applicationSetting.Id}`,
          OperationMode: OperationModesEnum.ApplicationMap,
          ApplicationMode: ApplicationModesEnum.Variable,
          Text: `${this.translationStore.FindTranslationForSelectedLanguage(OperationModesEnum.ApplicationMap)}${applicationSettingName}`,
          Category: 'OperationMode_Group_Map',
          ApplicationSetting: applicationSetting
        });
      }
    }
    return;
  }

  private _canSaveCheck(canSave: boolean): void {
    if (canSave && this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(this._operationModeAppSetting.OperationMode)) {
      const stat = this.nFertilizationStore.Listen(s => s.fieldNPlanningStatistic).getValue();
      if (stat === null || stat.length === 0) {
        return;
      }
      const ids = stat.map(_ => _.PlanId);
      this.mapStore.Layers.NPlanningLayerSourceInit(this.routerStore.Listen(s => s.url).getValue(), ids);
      const statistic = {
        Max: stat.Reduce((target, ele) => {
          if (ele.Max > target) {
            return ele.Max;
          }
          return target;
        }, 0),
        ElementId: 5,
        ProductId: this._formValues['Product'],
        Min: stat.Reduce((target, ele) => {
          return target < ele.Min ? target : ele.Min;
        }, stat.FirstOrDefault().Min),
        Average: stat.Reduce((target, ele) => {
          if (target < ele.Mean) {
            return ele.Mean;
          }
          return target;
        }, 0)
      };
      if (statistic.Average === 0) {
        this._clearMap();
      } else {
        this.mapStore.Legends.onNPlanningChanged.emit(statistic);
      }
    }
  }

  private _save(): void {
    const counts = this.items$.getValue().reduce((acc, item) => {
      if (item['ECStage'] in acc) {
        acc[item['ECStage']]++;
      } else {
        acc[item['ECStage']] = 1;
      }
      return acc;
    }, {});
    let mostFrequentValue = null;
    let highestCount = 0;
    for (const value in counts) {
      if (counts[value] > highestCount) {
        highestCount = counts[value];
        mostFrequentValue = value;
      }
    }
    const formsOperationMode = this._operationModeAppSetting?.OperationMode;
    const summaryApplicationMode = this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === this._formValues['Application']);
    const summaryOperationMode = this.operationModesStore.Listen(s => s.data).getValue().Find((o) => o.Key === formsOperationMode);
    // Do the _summaryForEdit plain or simple in file
    const summary = {
      ApplicationDate: this.dateService.getDateNoon(this._formValues['FertilizationDate']),
      AdditionalValue: {
        DeadBiomass: this._formValues['DeadBioMass'] ?? null,
        ExpectedYield: this._formValues['YieldExpectation'] ?? null,
        NMinPotential: this._formValues['Potential'] ?? null
      },
      ApplicationMode: summaryApplicationMode,
      ECValue: mostFrequentValue,
      OperationMode: summaryOperationMode,
      Slope: this.nFertilizationPlantProtectionService.getSlope(formsOperationMode, this._formValues['ControlFactor'],
        this._isRapeCrop, this._operationModeAppSetting?.ApplicationSetting),
      Threshold: this._formValues['Threshold'],
      Title: this._formValues['Note'],
      Unit: this.unitStore.getUnit('kgN/ha'),
      UserApplicationConstant: summaryOperationMode.Key === OperationModesEnum.TargetValue
        ? this._formValues['TargetRate'] : this._formValues['Constant'],
      UserApplicationMaximum: summaryApplicationMode.Key !== ApplicationModesEnum.Constant
        ? summaryOperationMode.Key !== OperationModesEnum.TargetValue
          ? this._formValues['Maximum']
          : this._formValues['TargetRate'] + this._formValues['ControlRange']
        : this._formValues['Constant'],
      UserApplicationMinimum: summaryApplicationMode.Key !== ApplicationModesEnum.Constant
        ? summaryOperationMode.Key !== OperationModesEnum.TargetValue
          ? this._formValues['Minimum']
          : this._formValues['TargetRate'] - this._formValues['ControlRange']
        : this._formValues['Constant'],
      UserApplicationRate: summaryApplicationMode.Key !== ApplicationModesEnum.Constant
        ? summaryOperationMode.Key !== OperationModesEnum.TargetValue
          ? this._formValues['Amount']
          : this._formValues['TargetRate']
        : this._formValues['Constant'],
      FarmId: this.loginStore.SelectedFarmId,
    } as INFertilizationSummary;
    const fields = this._selectedFields$.getValue();
    const planBooks = this.items$.getValue().map((item) => {
      const field = fields.find((f) => f.Id === item.Id);
      const nPlanningPlanBookData = this._getNPlanningPlanBookData(field.Geom.Id);
      const planId = item.PlanId !== undefined ? item.PlanId : ApGuidUtil.getEmptyGuid();
      const planBookApplicationMode = this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === item.ApplicationMode);
      const planBookOperationMode = this.operationModesStore.Listen(s => s.data).getValue().Find((o) => o.Key === item.OperationMode);
      return {
        Id: planId,
        ProductId: !this._formValues['Product'] ? 0 : this._formValues['Product'],
        ApplicationMode: planBookApplicationMode,
        OperationMode: planBookOperationMode,
        FieldGeomId: field.Geom.Id,
        MainCropId: field.CropId,
        ApplicationDate: this.dateService.getDateNoon(item['Date']),
        ApplicationConst: item['Constant'],
        ApplicationMax: planBookApplicationMode.Key === ApplicationModesEnum.Constant ? item['Constant'] : item['Maximum'],
        ApplicationMin: planBookApplicationMode.Key === ApplicationModesEnum.Constant ? item['Constant'] : item['Minimum'],
        ApplicationRate: item['TargetRate']
          ? item['TargetRate']
          : (planBookApplicationMode.Key === ApplicationModesEnum.Constant ? item['Constant'] : item['Amount']),
        ECValue: +item['ECStage'],
        Element: ApElementType.N,
        Factor: 1,
        Slope: nPlanningPlanBookData.ControlFactor,
        SecondCropId: field.SecondCropId,
        Summary: summary,
        Threshold: nPlanningPlanBookData.Threshold,
        FarmId: this.loginStore.SelectedFarmId,
        FieldId: item.Id,
        ExportDriver: item['Driver']?.Id ?? null,
        ExportMachine: item['Machine']?.Id ?? null,
        ExportInstrument: item['Instrument']?.Id ?? null,
        Geom: this.fieldStore.getCurrentFieldGeom(field.Id.toString())?.Geom,
        Unit: this.unitStore.getUnit('kgN/ha'),
        JobInput: JSON.stringify(item['ScanData'])
      } as INFertilizationPlanBook;
    });
    this.nFertilizationStore.SaveNFertilizationPlanning(planBooks);
  }

  private _isRemainingValueCouldBeApplied(operationModeKey: string): boolean {
    return this.nFertilizationCommonEntryService.isApplicationMapOrAbsolute(operationModeKey as OperationModesEnum)
      || operationModeKey === OperationModesEnum.Constant
      || operationModeKey === OperationModesEnum.TargetValue;
  }

  private _updateOverviewItems(submitData: { ids: any[], value: any }): void {
    this.items$.getValue().forEach((planBookGridItem) => {
      if (submitData.ids.includes(planBookGridItem.Id)) {
        const date = planBookGridItem.Date;
        const copiedPlanBookGridItem = ObjectFactory.Copy(planBookGridItem);
        const copiedSubmitDataValue = ObjectFactory.Copy(submitData.value);
        planBookGridItem = ObjectFactory.Merge(copiedPlanBookGridItem, copiedSubmitDataValue);
        planBookGridItem.Date = date;
        if (planBookGridItem['OperationMode'] === OperationModesEnum.TargetValue) {
          planBookGridItem['Minimum'] = planBookGridItem['TargetRate'] - planBookGridItem['ControlRange'];
          planBookGridItem['Maximum'] = planBookGridItem['TargetRate'] + planBookGridItem['ControlRange'];
          planBookGridItem['Constant'] = planBookGridItem['TargetRate'];
        }
        const planBook = this._getNPlanningPlanBookData(planBookGridItem['Geom']?.Id);
        planBook.ErrorMessage = '';
        planBook.HasError = false;
        planBook.ECStage = Number.isFinite(planBookGridItem['ECStage']) ? planBookGridItem['ECStage'] : planBook.ECStage;
        planBook.Minimum = Number.isFinite(planBookGridItem['Minimum']) ? planBookGridItem['Minimum'] : planBook.Minimum;
        planBook.Maximum = Number.isFinite(planBookGridItem['Maximum']) ? planBookGridItem['Maximum'] : planBook.Maximum;
        planBook.Threshold = Number.isFinite(planBookGridItem['Threshold']) ? planBookGridItem['Threshold'] : planBook.Threshold;
        planBook.ControlFactor = Number.isFinite(planBookGridItem['ControlFactor']) ? planBookGridItem['ControlFactor'] : planBook.ControlFactor;
        planBook.ControlFactorDescription = this.nFertilizationPlantProtectionService.getControlFactorDescription(
          this._operationModeAppSetting?.OperationMode, planBook.ControlFactor,
          this._operationModeAppSetting?.ApplicationSetting, false);
        planBook.Amount = Number.isFinite(planBookGridItem['TargetRate']) ? planBookGridItem['TargetRate'] : planBookGridItem['Amount'];
        planBook.Constant = planBookGridItem['Constant'];
        planBook.DeadBioMass = planBookGridItem['DeadBioMass'];
        planBook.Driver = planBookGridItem['Driver'];
        planBook.Instrument = planBookGridItem['Instrument'];
        planBook.Machine = planBookGridItem['Machine'];
        if (this._operationModeAppSetting?.OperationMode === OperationModesEnum.TargetValue) {
          planBook.ControlRange = Number.isFinite(planBookGridItem['ControlRange']) ? planBookGridItem['ControlRange'] : planBook.ControlRange;
          planBook.TargetRate = Number.isFinite(planBookGridItem['TargetRate']) ? planBookGridItem['TargetRate'] : planBook.TargetRate;
        }
        if (planBook.OperationModeKey === OperationModesEnum.ApplicationMap) {
          planBook.ThresholdAbs = planBook.ScanData.NUptakeAvg * (planBook.Threshold / 100);
        }
        if (this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(this._operationModeAppSetting?.OperationMode)) {
          planBook.ColumnLoading = true;
          this._initializeGridOverviewItem(true, false);
          this._createNPlanningRasterJob(
            planBook.PlanId,
            planBook.ScanData,
            planBook.FieldGeomId,
            this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === planBookGridItem['ApplicationMode']).Id,
            planBook.nUptake ?? null,
            planBook.Minimum,
            planBook.Maximum,
            planBook.ThresholdAbs ?? planBook.Threshold,
            planBook.ControlFactor,
            planBook.Amount,
            planBook.Constant,
            planBook.DeadBioMass
          );
        } else {
          this._initializeGridOverviewItem(false, false);
        }
      }
    });
  }

  private _createNPlanningRasterJob(planId: IGuid, bestScan: BestScanData, fieldGeomId: IGuid, applicationMode: number,
                                    nUptake: number | undefined, minimum: number, maximum: number, threshold: number,
                                    slope: number, appleRate: number, constant: number, deadBioMass: number): void {
    const nFertPlanId = bestScan?.ScanType === BestScanType.NFertilizationSensor
      ? bestScan.PlanId : ApGuidUtil.getEmptyGuid();
    const ppPlanId = bestScan?.ScanType === BestScanType.PlantProtectionSensor
      ? bestScan.PlanId : ApGuidUtil.getEmptyGuid();
    const satelliteId = bestScan?.ScanType === BestScanType.SatelliteScan
      ? bestScan.SatId : ApGuidUtil.getEmptyGuid();
    const satelliteScanType = bestScan?.ScanType === BestScanType.SatelliteScan && bestScan?.SatelliteScan === ScanType.Autumn
      ? ScanType.Autumn : ScanType.Regular;
    const planningData: INPlanningData = {
      PlanId: planId,
      NdPlanId: nFertPlanId,
      PpPlanId: ppPlanId,
      SatId: satelliteId,
      AutumnScan: satelliteScanType,
      NUptake: nUptake ?? null,
      FieldGeomId: fieldGeomId,
      ApplicationMode: applicationMode,
      Minimum: minimum,
      Maximum: maximum,
      Constant: constant,
      Slope: slope,
      DeadBioMass: deadBioMass ?? 0,
      Threshold: threshold,
      // use juggle-check for null and undefined check and additional check for isFinite().
      // The "+" operator does not handle undefined cases properly - the result would be "NaN"
      AppleRate: (appleRate != null && isFinite(+appleRate)) ? +appleRate : 0
    };
    this.nFertilizationStore.CreateNPlanningRasterJob(planningData);
  }

  private _createNPlanningJob(): void {
    this._clearMap();
    this._nPlanBooks.forEach((item) => {
      const applicationMode = this.applicationModesStore.Listen(s => s.data).getValue().Find((a) => a.Key === item.ApplicationModeKey);
      this._createNPlanningRasterJob(
        item.PlanId,
        item.ScanData,
        item.FieldGeomId,
        applicationMode.Id,
        item.nUptake ?? null,
        item.Minimum,
        item.Maximum,
        item.ThresholdAbs ?? item.Threshold,
        item.ControlFactor,
        item.OperationModeKey === OperationModesEnum.Constant
          ? 0
          : item.TargetRate ? item.TargetRate : item.Amount,
        item.Constant,
        item.DeadBioMass
      );
    });
  }

  private _clearMap(): void {
    MapFactoryStyler.Instance.clearStyleCache();
    this.mapStore.Layers.NApplicationMapLayer.clear();
    this.mapStore.Layers.Clear();
    this.mapStore.Legends.removeLegend(this.mapStore.Legends.NPlanningLegend);
  }

  private _fieldSelection(): void {
    if (this._currentStep === ApBaseWizardSteps.Selection) {
      let selectedFieldIds: string[];
      const selectedFieldItems = (this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[]);
      if (selectedFieldItems?.length > 0) {
        selectedFieldIds = selectedFieldItems.map(x => x.Id.toString());
        this.fieldStore.changeSelectedField(selectedFieldIds);
      } else {
        this.fieldStore.zoomFarmFields();
      }
      return;
    }
    if (this._currentStep === ApBaseWizardSteps.Overview) {
      let selectedFieldIds: string[];
      const selectedPlanFields = this.dynComponent.getSelectedItems();
      if (selectedPlanFields?.length > 0) {
        selectedFieldIds = selectedPlanFields.map(x => x.Id.toString());
      } else {
        selectedFieldIds = this.dynComponent.items.map(x => x.Id.toString());
      }
      this.fieldStore.changeSelectedField(selectedFieldIds);
    }
  }

  private _generateStats(): void {
    if (this._currentStep === ApBaseWizardSteps.Selection) {
      // TODO: Wir brauchen hier ein vernünftiges Model für die items. Bis zum refactoring verwenden wir hier any.
      let items = this.dynComponent.getSelectedItems() as INFertilizationPlanFieldToSelectGridItem[];
      if (!items || items.length <= 0) {
        // fallback => use all if nothing is selected
        items = this.dynComponent.items as INFertilizationPlanFieldToSelectGridItem[];
      }
      // put it on top of callstack to avoid lagging when user changes the selection
      setTimeout(() => {
        this.nPlanningEntryService.generateFieldStatistic(items);
      });
      return;
    }
    if (this._currentStep === ApBaseWizardSteps.Details) {
      // put it on top of callstack to avoid lagging when user changes the selection
      setTimeout(() => {
        this.nPlanningEntryService.generateFieldStatistic(this._selectedFields$.getValue());
      });
      return;
    }
    if (this._currentStep === ApBaseWizardSteps.Overview
      && this.nFertilizationPlantProtectionService.isOperationModeAnyOfMapsOrConstant(this._operationModeAppSetting?.OperationMode)) {
      // put it on top of callstack to avoid lagging when user changes the selection
      setTimeout(() => {
        this.nPlanningEntryService.generateOverviewStatistic(this._operationModeAppSetting?.OperationMode,
          this.dynComponent.getSelectedItems(), this.dynComponent.items);
      });
      return;
    }
    this.statisticStore.removeStatisticData();
  }

  private _isVariablePossible(): boolean {
    return this._selectedFields$?.getValue()?.some((f) => f.Status === 1) ?? false;
  }

  private _onCloseForm(): void {
    this._clearMap();
    this.statisticStore.removeStatisticData();
    setTimeout(() => this.formStore.closeForm(), 1);
  }

  private getDefaultBestScanStatus(): IGridStatus {
    return {
      state: -1,
      class: 'ap-status-grey',
      description: ''
    };
  }
}
